import { cn, Pill } from 'component-library';
import { ReactNode } from 'react';

import { I18String } from '@/components/widgets/a/I18String/I18String';

type PillWidgetProps = {
  i18nPath?: string;
  text?: string;
  className?: string;
  showMarker?: boolean;
  styles?: {
    background?: string;
    color?: string;
  };
  children?: ReactNode;
};

export const PillWidget = ({ i18nPath, text, className, showMarker, styles, children }: PillWidgetProps) => {
  return (
    <Pill
      style={styles}
      className={cn('typography-body2Semibold rounded-lg py-1 px-2', className)}
      leftAdornment={
        showMarker ? <div className='w-2 h-2 rounded-full' style={{ backgroundColor: styles?.color }}></div> : null
      }
      data-testid='pill-widget'
    >
      {i18nPath && <I18String i18nPath={i18nPath} />}
      {text && <>{text}</>}
      {children}
    </Pill>
  );
};
